import React from 'react';
import UserChecklist from '../components/UserChecklist';
import SeoComp from '../components/SeoComp';

const UserChecklistPage: React.FC = () => {

    return (
        <div className="min-h-screen-header-tabs p-4 md:p-8">
            <SeoComp />
            <div className="max-w-3xl mx-auto">
                <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6">Your Research Journey</h1>
                <p className="text-gray-600 mb-8">
                    Track your progress and discover all the features AnswerThis has to offer.
                    Complete these tasks to make the most of your research experience.
                </p>

                <UserChecklist showCompleted={true} />

                <div className="mt-8 p-4 bg-white rounded-lg shadow-sm border border-gray-200">
                    <h2 className="text-lg font-semibold text-gray-800 mb-2">Why complete these tasks?</h2>
                    <p className="text-gray-600 text-sm">
                        Each task is designed to help you explore the key features of AnswerThis and
                        improve your research workflow. By completing all tasks, you'll gain a comprehensive
                        understanding of how our platform can accelerate your research process.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default UserChecklistPage; 